import styled from 'styled-components';

const ButtonGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 0.75rem;

  @media (min-width: 600px) {
    grid-template-columns: 1fr 1fr;
  }
`;

export default ButtonGrid;